import jiffyForCourierDark from "../assets/svg/jiffyForCourier_dark.svg";
import jiffyForCourier from "../assets/svg/jiffyForCourier.svg";
import CourierLightList1 from "../assets/img/courier_light_list_img_1.png";
import CourierList1 from "../assets/img/courier_list_img_1.png";
import CourierLightList2 from "../assets/img/courier_light_list_img_2.png";
import CourierList2 from "../assets/img/courier_list_img_2.png";
import CourierLightList3 from "../assets/img/courier_light_list_img_3.png";
import CourierList3 from "../assets/img/courier_list_img_3.png";
import CourierLightList4 from "../assets/img/courier_light_list_img_4.png";
import CourierList4 from "../assets/img/courier_list_img_4.png";
//
import jiffyForBusinessesDark from "../assets/svg/jiffyForBusinesses_dark.svg";
import jiffyForBusinessesImg from "../assets/svg/jiffyForBusinesses.svg";
import BusinessLightList1 from "../assets/img/businesses_light_list_img_1.png";
import BusinessList1 from "../assets/img/businesses_list_img_1.png";
import BusinessLightList2 from "../assets/img/businesses_light_list_img_2.png";
import BusinessList2 from "../assets/img/businesses_list_img_2.png";
import BusinessLightList3 from "../assets/img/businesses_light_list_img_3.png";
import BusinessList3 from "../assets/img/businesses_list_img_3.png";
//
import jiffyForYouDark from "../assets/svg/jiffyForYou_dark.svg";
import jiffyForYouImg from "../assets/svg/jiffyForYou.svg";
import YouLightList1 from "../assets/img/you_light_list_img_1.png";
import YouList1 from "../assets/img/you_list_img_1.png";
import YouLightList2 from "../assets/img/you_light_list_img_2.png";
import YouList2 from "../assets/img/you_list_img_2.png";
import YouLightList3 from "../assets/img/you_light_list_img_3.png";
import YouList3 from "../assets/img/you_list_img_3.png";
//
import businessesOfferingsListDark1 from "../assets/img/business_list_offering_img_1.png";
import businessesOfferingsList1 from "../assets/img/business_list_offering_dark_img_1.png";
import businessesOfferingsListDark2 from "../assets/img/business_list_offering_img_2.png";
import businessesOfferingsList2 from "../assets/img/business_list_offering_dark_img_2.png";
import businessesOfferingsListDark3 from "../assets/img/business_list_offering_img_3.png";
import businessesOfferingsList3 from "../assets/img/business_list_offering_dark_img_3.png";

export const jiffyForCouriers = {
  topLine: "JIFFY FOR COURIERS",
  headline: "We help you optimize and grow your business",
  description:
    "Jiffy gives you access to a pool of customers and we will be with you along the way helping you track and manage your activities",
  imgStart: true,
  lightBg: true,
  alt: "Couriers",
  start: "",
  img: jiffyForCourierDark,
  imgDark: jiffyForCourier,
  list: [
    {
      title: "Real time process and earnings dashboard",
      imageDark: CourierLightList1,
      image: CourierList1,
    },
    {
      title: "Simplified payment for you and your customers",
      imageDark: CourierLightList2,
      image: CourierList2,
    },
    {
      title: "Manifest Collection",
      imageDark: CourierLightList3,
      image: CourierList3,
    },
    {
      title: "In-time notification for you and your customers",
      imageDark: CourierLightList4,
      image: CourierList4,
    },
  ],
};

export const jiffyForBusinesses = {
  topLine: "JIFFY FOR BUSINESSES",
  headline: "Sell Online. Deliver Online. Get More Customers",
  description:
    "Jiffy will help you fulfil your promise to your clients,we power 3rd party logistics businesses",
  imgStart: false,
  lightBg: false,
  alt: "Businesses",
  start: "",
  img: jiffyForBusinessesDark,
  imgDark: jiffyForBusinessesImg,
  list: [
    {
      title: "Simplified process and manifest collection",
      imageDark: BusinessLightList1,
      image: BusinessList1,
    },
    {
      title: "Provide best experience",
      imageDark: BusinessLightList2,
      image: BusinessList2,
    },
    {
      title: "Deliver your product in a jiffy",
      imageDark: BusinessLightList3,
      image: BusinessList3,
    },
  ],
};

export const jiffyForYou = {
  topLine: "JIFFY FOR YOU",
  headline: "Smart delivery of your package to anywhere you want",
  description: "We do more than pick-up and drop-off of sendables",
  imgStart: false,
  lightBg: true,
  alt: "Businesses",
  start: "",
  img: jiffyForYouDark,
  imgDark: jiffyForYouImg,
  list: [
    {
      title: "Simplified process",
      image: YouLightList1,
      imageDark: YouList1,
    },
    {
      title: "We provide the best experiences",
      image: YouLightList2,
      imageDark: YouList2,
    },
    {
      title: "Best affordable deals",
      image: YouLightList3,
      imageDark: YouList3,
    },
  ],
};

export const businessesOfferingsList = [
  {
    title: "Make booking easier",
    description:
      "Clients never have to leave your website, Google, or IG to schedule appointments",
    imageDark: businessesOfferingsListDark1,
    image: businessesOfferingsList1,
  },
  {
    title: "Reduce process flows",
    description:
      "Send automated reminders via text message and auto-charge for no-shows",
    imageDark: businessesOfferingsListDark2,
    image: businessesOfferingsList2,
  },
  {
    title: "Build lasting relationships",
    description:
      "Advertise new offerings and keep clients coming back with email and sms marketing",
    imageDark: businessesOfferingsListDark3,
    image: businessesOfferingsList3,
  },
];

export const FOOTER_DATA = [
  {
    title: "About",
    links: [
      { label: "Features", link: "#" },
      { label: "Pricing", link: "#" },
      { label: "Support", link: "#" },
      { label: "Forums", link: "#" },
    ],
  },
  {
    title: "Project",
    links: [
      { label: "Contribute", link: "#" },
      { label: "Media assets", link: "#" },
      { label: "Changelog", link: "#" },
      { label: "Releases", link: "#" },
    ],
  },
  {
    title: "Community",
    links: [
      { label: "Join Discord", link: "#" },
      { label: "Follow on Twitter", link: "#" },
      { label: "Email newsletter", link: "#" },
      { label: "GitHub discussions", link: "#" },
    ],
  },
];
